import React, { useState, useReducer } from "react";
import { Button, Form, Modal, Dropdown } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";
import { AvOptions } from "./DropdownOptions/AvOptions";
import { SphereOptions } from "./DropdownOptions/SphereOptions";
import { CylindreOptions } from "./DropdownOptions/CylindreOptions";
import { AxeOptions } from "./DropdownOptions/AxeOptions";
import { AddOptions } from "./DropdownOptions/AddOptions";
import MODAL_CHOICE_LUNNETTES_FAST from "./Modal_choice_lunnettes_fast";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const [NewAVOptions, set_Od_Val] = useState(AvOptions);
  const [NewSphereOptions, set_Od_SphereOptions] = useState(SphereOptions);
  const [NewCylindreOptions, set_Od_CylindreOptions] =
    useState(CylindreOptions);
  const [NewAxeOptions, set_Od_AxeOptions] = useState(AxeOptions);
  const [NewAddOptions, set_Od_AddOptions] = useState(AddOptions);

  const { ID, syncData, AuthState } = props;

  const functionCorrectioFinnale = async () => {
    let OGValueToBe;
    let ODValueToBe;

    if (state.sphOD && state.cylOD && state.addOD) {
      ODValueToBe = ` ${state.sphOD} (${state.cylOD} à ${state.axeOD}) Add : ${state.addOD}`;
    } else if (state.sphOD && state.cylOD && !state.addOD) {
      ODValueToBe = ` ${state.sphOD} (${state.cylOD} à ${state.axeOD}) `;
    } else if (state.sphOD && !state.cylOD && state.addOD) {
      ODValueToBe = ` ${state.sphOD}  Add : ${state.addOD}`;
    } else if (state.sphOD && !state.cylOD && !state.addOD) {
      ODValueToBe = ` ${state.sphOD}`;
    } else if (!state.sphOD && state.cylOD && !state.addOD) {
      ODValueToBe = ` VL : (${state.cylOD} à ${state.axeOD})`;
    } else if (!state.sphOD && state.cylOD && state.addOD) {
      ODValueToBe = ` VL : (${state.cylOD} à ${state.axeOD}) VP: Add : ${state.addOD}`;
    } else if (!state.sphOD && !state.cylOD && state.addOD) {
      ODValueToBe = ` VP: Add : ${state.addOD}`;
    } else if (!state.sphOD && !state.cylOD && !state.addOD) {
      ODValueToBe = ``;
    }
    // //////////////////////////////////////////OG
    if (state.sphOG && state.cylOG && state.addOG) {
      OGValueToBe = ` ${state.sphOG} (${state.cylOG} à ${state.axeOG}) Add : ${state.addOG}`;
    } else if (state.sphOG && state.cylOG && !state.addOG) {
      OGValueToBe = ` ${state.sphOG} (${state.cylOG} à ${state.axeOG}) `;
    } else if (state.sphOG && !state.cylOG && state.addOG) {
      OGValueToBe = ` ${state.sphOG} Add : ${state.addOG}`;
    } else if (state.sphOG && !state.cylOG && !state.addOG) {
      OGValueToBe = ` ${state.sphOG}`;
    } else if (!state.sphOG && state.cylOG && !state.addOG) {
      OGValueToBe = ` VL : (${state.cylOG} à ${state.axeOG})`;
    } else if (!state.sphOG && state.cylOG && state.addOG) {
      OGValueToBe = ` VL : (${state.cylOG} à ${state.axeOG}) VP: Add : ${state.addOG}`;
    } else if (!state.sphOG && !state.cylOG && state.addOG) {
      OGValueToBe = ` VP: Add : ${state.addOG}`;
    } else if (!state.sphOG && !state.cylOG && !state.addOG) {
      OGValueToBe = ``;
    }

    if (state.avOD) {
      ODValueToBe = `(AV : ${state.avOD}) ${ODValueToBe}`;
    }
    if (state.avOG) {
      OGValueToBe = `(AV : ${state.avOG}) ${OGValueToBe}`;
    }

    const ValuesToCreate = {
      fk_id_patientConsul: ID,
      created_by: AuthState.user_name,
      og: OGValueToBe,
      od: ODValueToBe,
      fk_id_examen: 13,
      observation: state.observation,
      fk_id_patientLunette: ID,
      avOD: state.avOD,
      sphOD: state.sphOD,
      cylOD: state.cylOD,
      axeOD: state.axeOD,
      addOD: state.addOD,

      avOG: state.avOG,
      sphOG: state.sphOG,
      cylOG: state.cylOG,
      axeOG: state.axeOG,
      addOG: state.addOG,
      TypeCO: "Correction finale",
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation/Lunettes`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  function dispatchMachineImports(params) {
    dispatch({ type: ACTION.IMPORT_DATA_MACHINE_CO_finale, payload: params });
  }

  async function getOneUser() {
    await axios
      .get(`${server}data/data.json`)
      .then((response) => {
        dispatchMachineImports(response.data);
      })
      .catch((error) => {
        dispatch({ type: "FETCH_ERROR", payload: error.response });
      });
  }

  function closeModal_remotely(params) {
    dispatch({ type: ACTION.CLOSE });
  }

  const cleaningTopCon = (param) => {
    let ProcessedValue = "";

    if (param === "  0.00") {
      ProcessedValue = "0.0";
      return ProcessedValue;
    } else if (param.includes("+")) {
      ProcessedValue = param.replace("+", "");
      ProcessedValue = ProcessedValue.replace(/ /g, "");
      return ProcessedValue;
    } else {
      ProcessedValue = param.replace(/ /g, "");
      return ProcessedValue;
    }

    // else if (param.includes("-")) {
    //     ProcessedValue = param.replace(/ /g, "")
    //     return ProcessedValue
    // }
  };

  async function getOneUserPIO() {
    await axios
      .get(`${server}dataTopCon/data.json`)
      .then((response) => {
        let TopConObject = {};

        // let Final_Prescription_R_SPH = response.data.a13.slice(2, 8)
        // let Final_Prescription_R_CYL = response.data.a13.slice(8, 14)
        // let Final_Prescription_R_AXS = response.data.a13.slice(14, 18)
        // let Final_Prescription_R_ADD = response.data.a15.slice(2, 8)
        let Final_Prescription_R_SPH = response.data.a9.slice(2, 8) !== "      " ? response.data.a9.slice(2, 8) : response.data.a57.slice(2, 8);
        let Final_Prescription_R_CYL = response.data.a9.slice(8, 14) !== "      " ? response.data.a9.slice(8, 14) : response.data.a57.slice(8, 14);
        let Final_Prescription_R_AXS = response.data.a9.slice(14, 18) !== "   " ? response.data.a9.slice(14, 18) : response.data.a57.slice(14, 18);
        let Final_Prescription_R_ADD = response.data.a15.slice(2, 8);

        let Final_Prescription_L_SPH = response.data.a10.slice(2, 8) !== "      " ? response.data.a10.slice(2, 8) : response.data.a58.slice(2, 8);
        let Final_Prescription_L_CYL = response.data.a10.slice(8, 14) !== "      " ? response.data.a10.slice(8, 14) : response.data.a58.slice(8, 14);
        let Final_Prescription_L_AXS = response.data.a10.slice(14, 18) !== "   " ? response.data.a10.slice(14, 18) : response.data.a58.slice(14, 18);
        let Final_Prescription_L_ADD = response.data.a16.slice(2, 8);

        TopConObject.Final_Prescription_R_SPH = cleaningTopCon(
          Final_Prescription_R_SPH
        );
        TopConObject.Final_Prescription_R_CYL = cleaningTopCon(
          Final_Prescription_R_CYL
        );
        TopConObject.Final_Prescription_R_AXS = cleaningTopCon(
          Final_Prescription_R_AXS
        );
        TopConObject.Final_Prescription_R_ADD = cleaningTopCon(
          Final_Prescription_R_ADD
        );
        TopConObject.Final_Prescription_L_SPH = cleaningTopCon(
          Final_Prescription_L_SPH
        );
        TopConObject.Final_Prescription_L_CYL = cleaningTopCon(
          Final_Prescription_L_CYL
        );
        TopConObject.Final_Prescription_L_AXS = cleaningTopCon(
          Final_Prescription_L_AXS
        );
        TopConObject.Final_Prescription_L_ADD = cleaningTopCon(
          Final_Prescription_L_ADD
        );

        dispatchMachineImports(TopConObject);
      })
      .catch((error) => {
        dispatch({ type: "FETCH_ERROR", payload: error.response });
      });
  }

  const handleAddition = (e, { value }) => {
    set_Od_Val((prevState) => [
      { key: value + Date.now(), text: value, value },
      ...prevState,
    ]);
  };
  const handleAdditionSphere = (e, { value }) => {
    set_Od_SphereOptions((prevState) => [
      { key: value + Date.now(), text: value, value },
      ...prevState,
    ]);
  };
  const handleAdditionCylindre = (e, { value }) => {
    set_Od_CylindreOptions((prevState) => [
      { key: value + Date.now(), text: value, value },
      ...prevState,
    ]);
  };
  const handleAdditionAxe = (e, { value }) => {
    const axeTransformValue = `${value}º`;
    set_Od_AxeOptions((prevState) => [
      {
        key: value + Date.now(),
        text: axeTransformValue,
        value: axeTransformValue,
      },
      ...prevState,
    ]);
  };
  const handleAdditionADD = (e, { value }) => {
    set_Od_AddOptions((prevState) => [
      { key: value + Date.now(), text: value, value: value },
      ...prevState,
    ]);
  };

  let nbrButtonToDisplay

  if (process.env.REACT_APP_MACHINES === "2") {

    nbrButtonToDisplay = <>
      <Button
        floated="right"
        color="linkedin"
        onClick={() => getOneUserPIO()}
      >
        Top Con
      </Button>
      <Button floated="right" color="violet" onClick={() => getOneUser()}>
        Huvitz
      </Button>
    </>

  } else if (process.env.REACT_APP_MACHINES === "3") {
    nbrButtonToDisplay =
      <Button floated="right" color="violet" onClick={() => getOneUser()}>
        Huvitz
      </Button>
  } else if (process.env.REACT_APP_MACHINES === "4") {
    nbrButtonToDisplay =
      <Button
        floated="right"
        color="linkedin"
        onClick={() => getOneUserPIO()}
      >
        Top Con
      </Button>
  }

  return (
    <>
      <Button
        color="yellow"

        onClick={() => dispatch({ type: ACTION.OPEN, size: "large" })}
      >
        CO FINALE
      </Button>

      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Header>
          Correction finale
          {nbrButtonToDisplay}

        </Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Field
                onAddItem={handleAddition}
                search
                selection
                fluid
                allowAdditions
                control={Dropdown}
                options={NewAVOptions}
                value={state.avOD}
                label="AV OD"
                placeholder="AV OD"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_avOD,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Od_Val(data);
              // }}
              />
              {/* SphereOptions */}
              <Form.Field
                onAddItem={handleAdditionSphere}
                search
                selection
                fluid
                allowAdditions
                control={Dropdown}
                options={NewSphereOptions}
                value={state.sphOD}
                label="Sphère OD"
                placeholder="Sphère OD"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_sphOD,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Od_Val(data);
              // }}
              />
              <Form.Field
                onAddItem={handleAdditionCylindre}
                search
                selection
                fluid
                allowAdditions
                control={Dropdown}
                options={NewCylindreOptions}
                value={state.cylOD}
                label="Cylindre OD"
                placeholder="Cylindre OD"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_cylOD,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Od_Val(data);
              // }}
              />
              <Form.Field
                onAddItem={handleAdditionAxe}
                search
                selection
                fluid
                allowAdditions
                control={Dropdown}
                options={NewAxeOptions}
                value={state.axeOD}
                label="Axe OD"
                placeholder="Axe OD"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_axeOD,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Od_Val(data);
              // }}
              />
              <Form.Field
                onAddItem={handleAdditionADD}
                search
                selection
                fluid
                allowAdditions
                control={Dropdown}
                options={NewAddOptions}
                value={state.addOD}
                label="Add OD"
                placeholder="Add OD"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_addOD,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_Od_Val(data);
              // }}
              />
            </Form.Group>
            <Form.Group className="centerthebtn" >
              <Button color="blue" onClick={() => dispatch({ type: ACTION.COPY_OD_TO_OG })}>
                Transmettre OD vers OG
              </Button>
            </Form.Group>
            <Form.Group widths="equal" className="colorOG">
              <Form.Field
                onAddItem={handleAddition}
                search
                selection
                fluid
                allowAdditions
                control={Dropdown}
                options={NewAVOptions}
                value={state.avOG}
                label="AV OG"
                placeholder="AV OG"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_avOG,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_OG_Val(data);
              // }}
              />
              {/* SphereOptions */}
              <Form.Field
                onAddItem={handleAdditionSphere}
                search
                selection
                fluid
                allowAdditions
                control={Dropdown}
                options={NewSphereOptions}
                value={state.sphOG}
                label="Sphère OG"
                placeholder="Sphère OG"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_sphOG,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_OG_Val(data);
              // }}
              />
              <Form.Field
                onAddItem={handleAdditionCylindre}
                search
                selection
                fluid
                allowAdditions
                control={Dropdown}
                options={NewCylindreOptions}
                value={state.cylOG}
                label="Cylindre OG"
                placeholder="Cylindre OG"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_cylOG,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_OG_Val(data);
              // }}
              />
              <Form.Field
                onAddItem={handleAdditionAxe}
                search
                selection
                fluid
                allowAdditions
                control={Dropdown}
                options={NewAxeOptions}
                value={state.axeOG}
                label="Axe OG"
                placeholder="Axe OG"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_axeOG,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_OG_Val(data);
              // }}
              />
              <Form.Field
                onAddItem={handleAdditionADD}
                search
                selection
                fluid
                allowAdditions
                control={Dropdown}
                options={NewAddOptions}
                value={state.addOG}
                label="Add OG"
                placeholder="Add OG"
                onChange={(e, data) =>
                  dispatch({
                    type: ACTION.Fill_FORM_DATA_3_COLUMN_addOG,
                    payload: data.value,
                  })
                }
              // onChange={(e, data) => {
              //     set_OG_Val(data);
              // }}
              />
            </Form.Group>
            {/* <TextArea
              placeholder="Ajouter une observation"
              //  onInput={(e, data) => dispatch({ type: ACTION.Fill_FORM_DATA, payload: data })}
              onChange={(e, data) =>
                dispatch({
                  type: ACTION.Fill_FORM_DATA_3_COLUMN_observation,
                  payload: data.value,
                })
              }
            /> */}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour
          </Button>
          {/* <Button positive onClick={functionCorrectioFinnale}>
                        Valider
                    </Button> */}
          <MODAL_CHOICE_LUNNETTES_FAST
            AuthState={AuthState}
            ID={ID}
            syncData={syncData}
            functionCorrectioFinnale={functionCorrectioFinnale}
            closeModal_remotely={closeModal_remotely}
          />
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Note;
